exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error{margin:30px 0;padding:15px;border:1px solid #900;color:#900;background:#ffb7b3}", ""]);

// exports
